<ng-container *ngIf="newContact">
  <h1 class="fs-24 text-championPurple mb-3 mb-lg-4">Add new contact</h1>
  <!-- <div class="fs-20 text-secondary mb-3 mb-lg-4">
      To generate recommendations, we need access to your energy details. Please provide your company information to
      continue.
  </div> -->
</ng-container>
<form [formGroup]="contactFormGroup">
  <section aria-label="contact-details">
    <ng-container *ngIf="showContactList">
      <h5 class="fs-18 fw600 text-bodyGrey mb-2">Add contact details</h5>
      <div class="row mb-4" *ngIf="listOfContacts?.length !== 1">
        <div class="col-lg-6 col-xl-4">
          <label class="fs-14 text-bodyGrey fw400 mb-1"> Select an authorized person for your site </label>
          <ng-select class="form-ngselect" [loading]="isContactLoading" placeholder="Select authorise person"
            (change)="selectedContact($event)" [searchable]="false" [clearable]="false">
            <ng-option *ngFor="let contact of listOfContacts; let i = index" [value]="contact">
              {{ contact.firstName + ' ' + contact.lastName }}
            </ng-option>
          </ng-select>
        </div>
      </div>
    </ng-container>

    <div class="row" *ngIf="showForm()">
      <div class="col-lg-6 col-xl-4 mb-4">
        <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Title</label>
        <ng-select class="form-ngselect" placeholder="Select title" formControlName="title" [searchable]="false"
          [clearable]="true">
          <ng-option *ngFor="let item of listOfTitles" [value]="item">{{ item }}</ng-option>
        </ng-select>
        <p *ngIf="contactFormGroup.get('title')?.touched && contactFormGroup.get('title')?.errors"
          class="text-danger fs-14 mt-1 mb-0">
          <span *ngIf="contactFormGroup.get('title')?.hasError('required')">Title is required</span>
        </p>
      </div>
      <div class="col-lg-6 col-xl-4 mb-4">
        <label for="" class="fs-14 text-bodyGrey fw400 mb-1">First name</label>
        <input type="text" class="form-control inputTyp1" formControlName="firstName" placeholder="Enter first name">
        <p *ngIf="contactFormGroup.get('firstName')?.touched && contactFormGroup.get('firstName')?.errors"
          class="text-danger fs-14 mt-1 mb-0">
          <span *ngIf="contactFormGroup.get('firstName')?.hasError('required')">First name is required</span>
          <span *ngIf="contactFormGroup.get('firstName')?.hasError('minlength')">First
            name should be at least 2 characters. please enter a valid first name.</span>
          <span *ngIf="contactFormGroup.get('firstName')?.hasError('pattern')">please enter a valid first
            name.</span>
        </p>
      </div>
      <div class="col-lg-6 col-xl-4 mb-4">
        <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Last name</label>
        <input type="text" class="form-control inputTyp1" formControlName="lastName" placeholder="Enter last name">
        <p *ngIf="contactFormGroup.get('lastName')?.touched && contactFormGroup.get('lastName')?.errors"
          class="text-danger fs-14 mt-1 mb-0">
          <span *ngIf="contactFormGroup.get('lastName')?.hasError('required')">Last name is required</span>
          <span *ngIf="contactFormGroup.get('lastName')?.hasError('minlength')">Last
            name should be at least 2 characters. please enter a valid last name.</span>
          <span *ngIf="contactFormGroup.get('lastName')?.hasError('pattern')">please enter a valid last
            name.</span>
        </p>
      </div>
      <div class="col-lg-6 col-xl-4 mb-4">
        <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Mobile</label>
        <input type="text" class="form-control inputTyp1" formControlName="phone" inputmode="numeric"
          placeholder="Enter phone">
        <p *ngIf="contactFormGroup.get('phone')?.touched && contactFormGroup.get('phone')?.errors"
          class="text-danger fs-14 mt-1 mb-0">
          <span *ngIf="contactFormGroup.get('phone')?.hasError('required')">Mobile is required</span>
          <span
            *ngIf="contactFormGroup.get('phone')?.hasError('minlength') || contactFormGroup.get('phone')?.hasError('pattern')">Please
            provide a valid mobile number.</span>
        </p>
      </div>
      <div class="col-lg-6 col-xl-4 mb-4">
        <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Email</label>
        <input type="email" class="form-control inputTyp1" formControlName="contactEmail" placeholder="Enter email">
        <p *ngIf="contactFormGroup.get('contactEmail')?.touched && contactFormGroup.get('contactEmail')?.errors"
          class="text-danger fs-14 mt-1 mb-0">
          <span *ngIf="contactFormGroup.get('contactEmail')?.hasError('required')">Email is required</span>
          <span *ngIf="contactFormGroup?.get('contactEmail')?.hasError('pattern')">Please provide a valid email
            address.</span>
        </p>
      </div>
    </div>
  </section>
</form>

<div *ngIf="newContact" class="mt-4 justify-content-lg-end d-grid d-lg-flex gap-3">
  <button type="button" class="btn-secondary" (click)="close()">
      Close
  </button>
  <button [disabled]="!contactFormGroup.valid" class="btn-primary" type="button" (click)="addContact()">
      Submit
  </button>
</div>